import LivedataDataCardsWidgets from '@sky-it-livedata/livedata-data-cards-widgets';
import { getServiceConfiguration } from '@sky-it-livedata-libraries/livedata-commons';
import { useServiceFactory, IUseService } from '@sky-it-livedata-libraries/livedata-commons-client';

// useServiceFactory is a factory, not a hook
// eslint-disable-next-line react-hooks/rules-of-hooks
export const useService: IUseService = useServiceFactory(
  new LivedataDataCardsWidgets(getServiceConfiguration('football'))
);

// useServiceFactory is a factory, not a hook
// eslint-disable-next-line react-hooks/rules-of-hooks
export const useMotorsportService = useServiceFactory(
  new LivedataDataCardsWidgets(getServiceConfiguration('motorsport'))
);
